// ABOUTME: Modal component to display order invoice products check results
// ABOUTME: Shows a data grid with order, invoice product, and amount columns

import { useTheme, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../theme";
import ShTextSkeleton from "../../theme/skeleton/ShTextSkeleton";
import { useCheckOrderInvoiceProductsQuery } from "../../../newapi/financial/invoiceSlice";
import { useEffect, useRef, useState } from "react";
import SHModal from "../../theme/Modal/SHModal";
import Subheading from "../../theme/text/Subheading";
import Shbutton from "../../theme/buttons/Shbutton";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import StraightenIcon from '@mui/icons-material/Straighten';
import SHQuickAction from "../../theme/Modal/SHQuickAction";
import Text from "../../theme/text/Text";
import { TabContextProvider } from "../../../contexts/TabContext";
import { GridFilterProvider } from "../../../contexts/GridFilterContext";
import GatedShDataGrid2 from "../../theme/datagrid2/GatedShDataGrid2";


const MCheckOrderInvoiceProducts = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();
    const ref = useRef();
    const [config, setConfig] = useState([]);
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    useEffect(() => {
        console.log(props.orderIds);
        if (props.orderIds?.length > 0) {
            setConfig({orderIds: props.orderIds});
        }
    }, [props.orderIds])

    const gridOptions = {
        export: false,
        disableCustomActionsOnPhone: false,
        isSidepanel: false,
        hide: true,
    };

    const columns = [
        {
            field: "relation",
            headerName: t("relation"),
            flex: 1,
            sortable: false,
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton />;
                }
                return params.row.relation;
            }
        },
        {
            field: "invoiceCategory",
            headerName: t("invoice_category"),
            flex: 1,
            sortable: false,
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton />;
                }
                return params.row.invoiceCategory;
            }
        },
        {
            field: "order",
            headerName: t("order"),
            flex: 1,
            sortable: false,
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton />;
                }

                              
                return (
                    <SHQuickAction
                        component={
                            <Box
                                sx={{
                                    px:1.5,
                                    display:"flex",
                                    flexDirection:"column"
                                }}
                            >
                                <Text light>{t("dimensions_and_weight")}</Text>
                                {params.row.shipmentDimensions?.map((item, index) => (
                                    <Text key={index}>{item.length}x{item.height}x{item.width} (mm) - {item.weight}g</Text>
                                ))}
                            </Box>
                        }
                    >
                        {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                            <Box
                                aria-owns={anchorEl ? 'simple-popover' : undefined}
                                aria-haspopup={false}
                                onMouseEnter={onMouseEnter}
                                onMouseLeave={onMouseLeave}
                                onTouchStart={onTouchStart}
                                sx={{
                                    width:1,
                                    display: "flex",
                                    alignItems: "center"
                                }}
                            >
                                <Text>{params.row.order}</Text>
                                <StraightenIcon sx={{ml: 1}}></StraightenIcon>
                            </Box>
                        )}
                    </SHQuickAction>
                );
            }
        },
        {
            field: "amount",
            headerName: t("amount"),
            flex: 1,
            sortable: false,
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton />;
                }
                return params.row.amount;
            }
        },
        {
            field: "invoiceProduct",
            headerName: t("invoice_product"),
            flex: 2,
            sortable: false,
            renderCell: (params) => {
                if (params.row.skeleton) {
                    return <ShTextSkeleton />;
                }
                return params.row.name;
            }
        },
    ];

    return (
        <SHModal
            open={props.open}
            onClose={props.handleClose}
            sx={{body: {minWidth: 900}}}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{t("calculated_costs_orders")}</Subheading>
            </Box>

            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    paddingTop: 2,
                    gap:2
                }}
            >
        <Box height={1} ref={ref} display={"flex"} flexDirection={"column"}>
            <TabContextProvider>
                <GridFilterProvider activeChild={"check_order_invoice_products"}>
                    <GatedShDataGrid2 key={theme.palette.mode + config.orderIds}
                        content={useCheckOrderInvoiceProductsQuery}
                        config={config}
                        gridOptions={gridOptions}
                        columns={columns}
                        customPaddingBottom={1}
                    />
                </GridFilterProvider>
            </TabContextProvider>
        </Box>
        </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    justifyContent:"space-between",
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={props.handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
            </Box>
        </SHModal>
    );
};

export default MCheckOrderInvoiceProducts;
